  import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

  Swiper.use([Navigation, Pagination, Autoplay]);

  const swiper = new Swiper('.js-swiper-container', {
    autoHeight: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    loop: true,
    speed: 500,

    pagination: {
      el: '.swiper-pagination',
    },
  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    on: {
      init: function () {
        setNavColor(this);
      },
    }
  });

  swiper.on('slideChange', function () {
    setNavColor(this);
  });

  function setNavColor(swiper){
    if(window.getComputedStyle(swiper.slides[swiper.activeIndex], null).getPropertyValue("background-color") == "rgb(0, 53, 148)"){
      if(!document.getElementsByClassName('ns-swiper__nav')[0].classList.contains('.ns-swiper__nav--white')){
        document.getElementsByClassName('ns-swiper__nav')[0].classList.add('ns-swiper__nav--white');
      }
    } else {
      document.getElementsByClassName('ns-swiper__nav')[0].classList.remove('ns-swiper__nav--white');
    }
  }
